<script>
	import {onMount} from 'svelte'
	import {API,SPINNER} from '../global.js'
	import {USER} from '../store.js'
	import CreditCard from "../common/CreditCard.svelte";
	import Numero from "../common/Numero.svelte";

	export let cobranza
	export let formapago
	export let fd = { importe:0, tarjeta:'', nrotarjeta:'', nrotarjetasrc:'', codigo:'', mesvence:'', anovence:'2021', 
					  titular:'', nrodocumento:'',observacion:'', isvalid:false }
	
	let theYear =(new Date()).getFullYear()
	let formdata = {}
	let meses = ['ENE','FEB','MAR','ABR','MAY','JUN','JUL','AGO','SET','OCT','NOV','DIC']
	// fd.anovence=theYear
	let cotizacion = 1.00

	
	$: {
		let CF = ((parseFloat(fd.importe)-(parseFloat(fd.importe)*formapago.coef1val)||0)).toFixed(2)
		fd.concepto = `${formapago.fpagotipo}${cobranza.idmoneda} ${cobranza.complejo} ${formapago.fpagotipo} ${formapago.cuotas} x ${cotizacion!==1?'$':cobranza.simbolo} ${(fd.importe*formapago.coef1val/formapago.cuotas).toFixed(2)} ( CF : ${-1*CF} ${parseFloat(fd.importe)<cobranza.importe*cotizacion?'PARCIAL':''})`
	}
/*
	onMount( async() => {
		fd.moneda=cobranza.idmoneda*1
		fd.simbolo = cobranza.simbolo+''
		console.log(formapago)
		if(formapago.cotizado!==1 && cobranza.idmoneda!==1 && formapago.cotizado!==cobranza.idmoneda){
			let rs = await fetch(`${API}/cotizacion/${formapago.cotizado}`)
			let ds = await rs.json()

			let query = `select cotizacion from monedas where idmoneda=${formapago.cotizado}`
			let data = await execQuery({query})
			cotizacion = data.data[0].cotizacion
			fd.moneda = 1
			fd.simbolo = '$'
			fd.conversion = cotizacion*1
		}
		fd.importe = (cobranza.importe*cotizacion).toFixed(2)
	})
*/

	onMount( async() => {
		fd.moneda=cobranza.idmoneda*1
		fd.simbolo = cobranza.simbolo+''

		if(formapago.cotizado!==1 && cobranza.idmoneda!==1 && formapago.cotizado!==cobranza.idmoneda){
			let rs = await fetch(`${API}/cotizacion/${formapago.cotizado}`)
			let ds = await rs.json()

			cotizacion = ds.data.Cotizacion
			fd.moneda = 1
			fd.simbolo = '$'
			fd.conversion = cotizacion*1
		}
		fd.importe = (cobranza.importe*cotizacion).toFixed(2)
	})


	function submit(){

	}

</script>

	<form class="row" on:submit|preventDefault="{submit}">
		
		<div class="mt-2 col-auto">
			<label class="mt3 ps2" for="">Importe</label>
			<input class="form-control form-control-sm" tabindex="-1" bind:value={fd.importe} readonly={$USER.aclist==='cliente'}>
		</div>	
		<div class="mt-2 col-auto">
			<label class="mt3 ps2" for="">Cuotas</label>
			<input class="form-control form-control-sm" tabindex="-1" size="2" 
				min=1 max=12 bind:value={formapago.cuotas} 
				readonly={!formapago.chcuotas || $USER.aclist==='cliente'}>
		</div>	

		<div class="fs-5 mt-2 col-12">{fd.concepto}</div>

		<div class="mt-2 col-4">
			<label class="mt3 ps2" for="">Tarjeta</label>
			<select bind:value={fd.tarjeta} class="form-control form-control-sm">
				{#each formapago.fpagoname.split(",") as tarj, index}
					<option>{tarj}</option> 
				{/each}
			</select>
		</div>
		<div class="mt-2 col-8">
			<label for="" class="mt3 ps2">Numero&nbsp;Tarjeta</label>
			<CreditCard class="form-control form-control-sm" bind:isvalid={fd.isvalid} bind:value={fd.nrotarjeta} bind:valuesrc={fd.nrotarjetasrc} />
		</div>

		<div class="mt-2 col-4">
			<label for="" class="mt3 ps2">Codigo</label>
			<Numero class="form-control form-control-sm" placeholder="Codigo" bind:value={fd.codigo} cantidad="4"/>
		</div>
		<div class="mt-2 col-4">
			<label for="" class="mt3 ps2">Mes&nbsp;Vence</label>
			<select bind:value={fd.mesvence} class="form-control form-control-sm">
				{#each meses as mes, index}
					<option>{mes}</option> 
				{/each}
			</select>
		</div>
		<div class="mt-2 col-4">
			<label for="" class="mt3 ps2 {fd.anovence<theYear?'fg-red':''}">Año&nbsp;Vence&nbsp;<i>YYYY</i></label>
			<Numero class="form-control form-control-sm" placeholder="Codigo" bind:value={fd.anovence} cantidad="4"/>
		</div>

		<div class="mt-2 col-8">
			<label for="" class="mt3 ps2">Tit.&nbsp;Tarjeta</label>
			<input class="form-control form-control-sm" placeholder="Titular"bind:value={fd.titular}>
		</div>
		<div class="mt-2 col-4">
			<label for="" class="mt3 ps2">Documento</label>
			<input class="form-control form-control-sm" placeholder="NroDocumento" bind:value={fd.nrodocumento}>
		</div>

		<div class="mt-2 col-12">
			<label for="" class="mt3 ps2">Observacion</label>
			<textarea class="form-control form-control-sm" rows=5 placeholder="Observacion" bind:value={fd.observacion}></textarea>
		</div>

	</form>
	

<style>
	label{ font-size: 0.8em;display: block; }
</style>
